import type { PropsWithChildren } from 'react';

import { SheetHeaderStyled } from './styles/SheetHeaderStyled'
import { useInternalSheetContext } from '../../InternalSheetContext'
import { IconButton } from '@ui/elements/Button'
import { Header } from '@ui/elements/Header'
import { IconMoveRight } from '@ui/elements/Icon/components/IconMoveRight'
import { Toolbar } from '@ui/elements/Toolbar'

interface ISheetHeaderProps {
  iconButtonLabel?: string
  onDismiss?: (event?: any) => void
}

export const SheetHeader = ({
  iconButtonLabel = 'Hide Sheet',
  onDismiss,
  children,
}: PropsWithChildren<ISheetHeaderProps>) => {
  const { setIsSheetOpen } = useInternalSheetContext()

  const onSheetClose = () => {
    if (onDismiss) onDismiss()

    setIsSheetOpen(false)
  }

  return (
    <SheetHeaderStyled>
      <Toolbar>
        <IconButton
          iconComponent={<IconMoveRight />}
          aria-label={iconButtonLabel}
          onClick={() => onSheetClose()}
        />
        <Header as='h4' ml={1}>
          {children}
        </Header>
      </Toolbar>
    </SheetHeaderStyled>
  )
}
